module.exports = __webpack_public_path__ + "img/list.fce51161.png";